import React from 'react';

import { InputLabel, Slider, Stack } from '@mui/material';

function change3ColumnsValue(value: number[], activeThumb: number): [number, number] {
  if (value[1] !== value[0]) {
    if (activeThumb === 0) {
      return [value[0] === 0 ? 1 : value[0], value[1]];
    }
    return [value[0], value[1] === 12 ? 11 : value[1]];
  }

  if (activeThumb === 0) {
    const clamped = Math.min(value[0], 10);
    return [clamped, clamped + 1];
  }
  const clamped = Math.max(value[1], 2);
  return [clamped - 1, clamped];
}

function change2ColumnsValue(value: number[]): [number] {
  if (typeof value[0] !== 'number') {
    return [6];
  }
  if (value[0] === 0) {
    return [1];
  }
  if (value[0] === 12) {
    return [11];
  }
  return [value[0]];
}

const SLIDER_STYLE = {
  bgcolor: 'grey.200',
  borderRadius: '4px',
  height: 35,
  padding: 0,
  '.MuiSlider-rail': { height: 24, borderRadius: 0, bgcolor: 'grey.400' },
  '.MuiSlider-thumb': {
    height: 32,
    width: 16,
    borderRadius: 0,
    border: '4px solid',
    borderColor: 'grey.200',
  },
};

type Props = {
  columnsCount: 2 | 3;
  value: [number] | [number, number];
  onChange: (val: [number] | [number, number]) => void;
};
export default function ColumnsWidthSlider({ columnsCount, value, onChange }: Props) {
  const handleChange = (ev: unknown, value: number | number[], activeThumb: number) => {
    if (!Array.isArray(value)) {
      return;
    }
    if (columnsCount === 3) {
      onChange(change3ColumnsValue(value, activeThumb));
    } else {
      onChange(change2ColumnsValue(value));
    }
  };

  return (
    <Stack spacing={1} alignItems="flex-start">
      <InputLabel shrink>Drag to resize columns</InputLabel>
      <Slider
        sx={SLIDER_STYLE}
        track={false}
        disableSwap
        onChange={handleChange}
        value={value}
        step={1}
        min={0}
        max={12}
      />
    </Stack>
  );
}
